<template>
  <div
    class="h-full text-app-color"
  >
    <div class="pt-40 md:pt-75 md:pr-25 pb-100 mx-auto bg-canvas
                min-h-full rounded-9 flex-grow flex flex-col max-w-950"
    >
      <!-- header -->
      <div class="relative px-30 md:pr-0 md:pl-60">
        <div class="flex md:items-center justify-between mt-4 mb-7 max-w-430">
          <p class="leading-none text-29 font-bold">Your inbox</p>
          <!-- notification button -->
          <SetNotifications
            class="z-10"
            title="Mute all notifications"
          />
        </div>
      </div>

      <!-- tabs -->
      <div class="mt-20 px-30 md:pr-0 md:pl-60 flex flex-wrap justify-center md:justify-start">
        <div v-for="(tab, index) in tabs" :key="index">
          <input :id="`tab${index}`" v-model="selected" type="checkbox" :value="tab" class="hidden">
          <label :for="`tab${index}`" class="w-130 md:w-100 h-35 md:h-30 bg-book rounded-4 text-app-color text-13 font-normal flex items-center justify-center cursor-pointer mr-8 mb-8 md:mb-0"
                 :class="{'bg-grey-main text-white': selected.includes(tab)}"
          >{{ tab }}</label>
        </div>
      </div>

      <!-- content -->
      <div class="px-30 mx-10 md:pr-0 md:pl-60 text-app-color">
        <div v-for="(item, index) in filtredInbox" :key="item.category + index">
          <div v-if="selected.includes(item.category) || selected.length === 0" class="mt-25">
            <div class="text-16 font-medium">{{ item.category }}</div>
            <div v-for="el in item.content" :key="el.id" class="mb-6 last:mb-0 text-15">
              <p v-if="item.category === 'Reminders'">
                <i class="icon-alarm mr-4 text-dacoralmine" />
                <span class="text-dacoralmine">{{ new Date(el.createdAt).getHours() + ':' + new Date(el.createdAt).getMinutes() }}</span> -
                {{ el.text }}
              </p>
              <p v-else>
                <span class="block opacity-30 text-12">
                  {{ getTime(el.createdAt) }}
                </span>
                <span class="border-l-2 border-pink-main mr-10" />{{ el.text }}
                <span v-if="item.category === 'Team'" class="text-10 ml-4">🎉</span>
                <i v-else-if="item.category !== 'Activity'" class="icon-notifications-off text-app-color text-16 opacity-30" />
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref, computed } from 'vue'
import { useStore } from 'vuex'

import SetNotifications from '@/components/shared/SetNotifications'

import { parseDate } from '@/plugins/filters'

export default defineComponent({
  components: { SetNotifications },

  setup () {
    const { getters } = useStore()

    const tabs = [
      'Chat',
      'Activity',
      'Reminders',
      'Team'
    ]
    const selected = ref([])
    const content = ref([
      {
        id: 1,
        createdAt: 'Tue Apr 28 2021 14:53:47 GMT+0300 (Eastern European Summer Time)',
        text: 'Lisa Vaitvanen mentioned you in Executive team chat.',
        category: 'Chat'
      },
      {
        id: 2,
        createdAt: 'Tue Apr 28 2021 14:53:47 GMT+0300 (Eastern European Summer Time)',
        text: 'Lisa Vaitvanen mentioned you in Executive team chat.',
        category: 'Chat'
      },
      {
        id: 3,
        createdAt: 'Tue Apr 27 2021 14:52:47 GMT+0300 (Eastern European Summer Time)',
        text: 'Lisa Vaitvanen mentioned you in Executive team chat.',
        category: 'Team'
      },
      {
        id: 4,
        createdAt: 'Tue Apr 21 2021 14:57:47 GMT+0300 (Eastern European Summer Time)',
        text: 'Lisa Vaitvanen mentioned you in Executive team chat.',
        category: 'Team'
      },
      {
        id: 14,
        createdAt: 'Tue Apr 21 2021 14:57:47 GMT+0300 (Eastern European Summer Time)',
        text: 'Lisa Vaitvanen mentioned you in Executive team chat.',
        category: 'Team'
      },
      {
        id: 5,
        createdAt: 'Tue Apr 27 2021 14:56:47 GMT+0300 (Eastern European Summer Time)',
        text: 'All-hands meeting',
        category: 'Reminders'
      },
      {
        id: 9,
        createdAt: 'Tue Apr 27 2021 14:56:47 GMT+0300 (Eastern European Summer Time)',
        text: 'All-hands meeting',
        category: 'Reminders'
      },
      {
        id: 6,
        createdAt: 'Tue Apr 27 2021 13:56:47 GMT+0300 (Eastern European Summer Time)',
        text: 'Alex Krinchivosu changed Webdesign',
        category: 'Activity'
      }
    ])

    const isDarkMode = computed(() => getters.isDarkMode)
    /* eslint-disable-next-line */
    const sortedInbox = computed(() => content.value.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)))

    const filtredInbox = []
    sortedInbox.value.reduce((prevItem, nextItem) => {
      if (prevItem.category === nextItem.category) {
        filtredInbox[filtredInbox.length - 1].content.push(nextItem)
      } else {
        filtredInbox.push({
          category: nextItem.category,
          content: [nextItem]
        })
      }

      return nextItem
    }, sortedInbox.value[sortedInbox.value.length - 1])

    function getTime (date) {
      const today = new Date().getDate()
      const yesterday = today - 1
      const createdAtItem = new Date(date)
      const getDateCreateAt = createdAtItem.getDate()

      if (today === getDateCreateAt) {
        return `Today ${createdAtItem.getHours()}:${createdAtItem.getMinutes()}`
      }

      if (yesterday === getDateCreateAt) {
        return `Yesterday ${createdAtItem.getHours()}:${createdAtItem.getMinutes()}`
      } else {
        return parseDate(createdAtItem, 'DD-MM-YYYY hh:mm')
      }
    }

    return {
      // data
      tabs,
      // refs
      selected,
      content,
      // computed
      isDarkMode,
      // function
      filtredInbox,
      getTime
    }
  }
})
</script>
